import { colors } from "constants/colors";
import styled from "styled-components";

export const StyledDialogContentContainer = styled.div`
  display: flex;
  column-gap: 1rem;
  align-items: flex-start;
`;

export const StyledCurrentMonitorContainer = styled.div`
  display: flex;
  flex-basis: 25%;
  flex-direction: column;
  justify-content: space-between;
  row-gap: 1rem;
  padding: 1rem;
`;

export const StyledUl = styled.ul`
  width: 100%;
  box-sizing: border-box;
  padding-left: 1rem;
`;

export const StyledLi = styled.li`
  padding: 0.3rem 0;
  list-style-type: disc;
  ::marker {
    color: ${colors.lightGray};
  }
`;

export const StyledMonitorSubmittedTextContainer = styled.div`
  display: flex;
  flex-basis: 50%;
  flex-direction: column;
  row-gap: 1rem;
  padding: 1rem;
`;
